import { ALCHEMIST_POTIONS, POTION_RECIPES, potionPotency, potionEffect, potionArt, potionArtMask } from '../../utils/arena/alchemist';
import { TEXT_BODY, TEXT_PRIMARY } from '../../lib/medievalTheme';
import { t } from '../../localization/t';
import { isFreePlay } from '../../utils/freePlay';

// Readied bottles announce exactly what the next eligible event will receive.
export default function ActivePotions({ alchemist, kind, floating = false }) {
  // Free play has no classes, so no Alchemist's bottles either.
  if (isFreePlay()) return null;
  const potions = ALCHEMIST_POTIONS.filter(p => POTION_RECIPES[p.key].kind === kind && alchemist?.active?.[p.key]?.uses > 0);
  if (!potions.length) return null;
  return (
    <div className="relative z-10 flex flex-wrap justify-center" style={{ gap: '0.75cqw', padding: '0.75cqw 2cqw', background: floating ? 'transparent' : 'rgba(10,8,6,0.8)' }} data-testid="active-potions">
      {potions.map(p => {
        const tier = potionPotency(alchemist.active[p.key].potency) || potionPotency('ordinary');
        return (
          <div key={p.key} className="flex items-center" style={{ gap: '0.5cqw', maxWidth: '38cqw' }}>
            <img src={potionArt(p.key)} alt="" style={{ width: '2.8cqw', height: '2.8cqw', objectFit: 'contain', maskImage: potionArtMask(p.key), maskSize: '100% 100%' }} />
            <div style={{ fontSize: '0.85cqw', color: TEXT_BODY }}>
              <div className="arena-heading" style={{ color: TEXT_PRIMARY }}>{t('{potency} Potion of {name}', { potency: t(tier.title), name: t(p.title) })}</div>
              <div>{potionEffect(p.key, tier.key)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
